import { Send } from "lucide-react";

const ITEMS = [
    "Tech & Elettronica",
    "Casa & Cucina",
    "Audio Premium",
    "Smartwatch & Wearables",
    "Offerte Lampo",
    "Gaming & Streaming",
    "Sport & Outdoor",
    "Bellezza & Benessere",
];

export default function Marquee() {
    return (
        <section
            aria-label="Categorie di offerte monitorate"
            data-testid="marquee"
            className="relative z-10 bg-ink py-4 shadow-[0_24px_60px_-24px_rgba(11,18,32,0.55)] sm:py-5"
        >
            <div className="marquee">
                <div className="marquee-track items-center">
                    {[0, 1].map((copy) => (
                        <div key={copy} aria-hidden={copy === 1} className="flex shrink-0 items-center">
                            {ITEMS.map((t, i) => (
                                <span key={`${copy}-${i}`} className="flex items-center gap-5 px-5 sm:gap-7 sm:px-7">
                                    <span className="whitespace-nowrap font-mono text-[11px] font-bold uppercase tracking-[0.25em] text-white/75 sm:text-sm sm:tracking-[0.3em]">
                                        {t}
                                    </span>
                                    <Send className="h-3 w-3 shrink-0 text-telegram-glow" />
                                </span>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
